// src/components/TagFilterChips.jsx
import React, { useState, useEffect } from 'react';
import { X, Loader2 } from 'lucide-react';
import { Badge } from '@/components/ui/badge.jsx';
import { apiCall } from '../utils/api';

export default function TagFilterChips({ selectedTags, onTagToggle }) {
  const [allTags, setAllTags] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTags();
  }, []);

  async function loadTags() {
    setLoading(true);
    try {
      const res = await apiCall('/charts/tags/');
      if (res.ok) {
        const data = await res.json();
        setAllTags(data.tags || []);
      }
    } catch (err) {
      console.error('Failed to load tags:', err);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="flex items-center gap-2 py-2">
        <Loader2 className="w-4 h-4 text-[#6a6a6a] animate-spin" />
        <span className="text-xs text-[#6a6a6a]">Loading tags...</span>
      </div>
    );
  }

  if (allTags.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-xs text-[#6a6a6a] font-medium">Tags:</span>
      {allTags.map(tag => {
        const isSelected = selectedTags.includes(tag.id);
        return (
          <button
            key={tag.id}
            onClick={() => onTagToggle(tag.id)}
            className={`
              inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium transition-all
              ${isSelected 
                ? 'bg-blue-500/20 text-blue-400 border border-blue-500/30 hover:bg-blue-500/30' 
                : 'bg-[#1a1a1a] text-[#a0a0a0] border border-[#2a2a2a] hover:bg-[#2a2a2a] hover:text-white'
              }
            `}
          >
            {tag.name}
            {isSelected && <X className="w-3 h-3" />}
          </button>
        );
      })}
    </div>
  );
}